import { getColorByConsume } from "../types/schemesColors";
import { changeDateTimeZone, toDay } from "./dayjsHelper";
import { truncateFloat } from "./generalHelper";
import { percentValue } from "./operationMath";

const getTableBackusHours = (areasArray = []) => {
    const update = areasArray.map(({ _id, additionalHours, beforeHours, comment, currency, amount, startedDate }, index) => {
        const textComment = comment ? { user: comment.userName, text: comment.text } : { user: "", text: "" };
        const { web, unity, desing, modeling, planning, testing = 0 } = additionalHours;
        return {
            key: _id,
            web,
            unity,
            desing,
            art3d: modeling,
            planning,
            testing,
            comment: textComment.text,
            user: textComment.user,
            currency,
            amount,
            createAt: startedDate,
            afterHours: { web, unity, desing, art3d: modeling, planning, testing },
            beforeHours: {
                web: beforeHours.web,
                unity: beforeHours.unity,
                desing: beforeHours.desing,
                art3d: beforeHours.modeling,
                planning: beforeHours.planning,
                testing: beforeHours.testing ?? 0,
            },
            numberIndex: index,
        };
    });
    const sortedActivities = update.sort((a, b) => {
        return new Date(b.createAt) - new Date(a.createAt);
    });

    const newNuberIndex = sortedActivities.map((array, index) => {
        return {
            ...array,
            numberIndex: index,
        };
    });
    return newNuberIndex;
};

export const getTableGraphAndIndication = (areas = [], budget) => {
    const areasInformation = {
        Planeación: { name: "Planeación", color: "#940bab", field: "planning" },
        "Diseño UI/UX": { name: "Diseño UI/UX", color: "#FF4081", field: "design" },
        "Arte 3D": { name: "Arte 3D", color: "#7C4DFF", field: "modeling" },
        "Programación Unity": { name: "Programación Unity", color: "#02BCD4", field: "unity" },
        "Programación Web": { name: "Programación Web", color: "#2ECD6F", field: "web" },
    };

    return areas.reduce(
        (acc, area) => {
            const areaInmersys = areasInformation[area.name];
            if (areaInmersys) {
                const { name, color, field } = areaInmersys;
                const budgetValue = budget[field] || budget.development[field];
                acc.tableIndication.push({
                    keyId: name,
                    name: name,
                    color: getColorByConsume(Math.abs(percentValue(budgetValue, area.totalTimeList))),
                    tracked: area.totalTimeList,
                    budget: budgetValue,
                    subtract: truncateFloat(budgetValue - area.totalTimeList),
                    field,
                    ...area,
                });
                acc.graphArea.push({
                    id: name,
                    label: name,
                    value: area.totalTimeList,
                    color: color,
                });
                return acc;
            }
            const indexTesting = acc.graphArea.findIndex((area) => area.label === "Testing");
            if (indexTesting === -1) {
                acc.tableIndication.push({
                    ...area,
                    keyId: "testing",
                    name: "Testing",
                    field: "testing",
                    tracked: area.totalTimeList,
                    budget: budget.development.testing || 0,
                    color: getColorByConsume(Math.abs(percentValue(budget.development.testing, area.totalTimeList))),
                    subtract: truncateFloat(budget.development.testing - area.totalTimeList),
                });
                acc.graphArea.push({
                    id: "testing",
                    label: "Testing",
                    value: area.totalTimeList,
                    color: "#9cc",
                });

                return acc;
            }
            acc.graphArea[indexTesting].value += area.totalTimeList;
            const indexTestingList = acc.tableIndication.findIndex((area) => area.name === "Testing");

            acc.tableIndication[indexTestingList].tracked += area.totalTimeList;
            acc.tableIndication[indexTestingList].subtract = acc.tableIndication[indexTestingList].tracked - budget.development.testing;

            return acc;
        },
        { tableIndication: [], graphArea: [] }
    );
};

const getProperties = (types = []) => {
    const allProperties = { maintenance: "mantenimiento", hardware: "hardware", metaverso: "metaverso" };
    return Object.entries(allProperties).reduce(
        (acc, [key, name]) => ({
            ...acc,
            [key]: types.includes(name),
        }),
        {}
    );
};

const getTeams = (team = {}, teamAdmin = {}) => {
    const namesAdmin = {
        peopleInChargeProject: "comercial",
        peopleInCharge: "responsible",
        leaders: "leader",
    };

    const teamAdminCorrectNames = Object.entries(teamAdmin).reduce(
        (acc, [key, value]) => ({
            ...acc,
            [namesAdmin[key] || key]: value,
        }),
        {
            comercial: [],
            responsible: [],
            leader: [],
        }
    );

    return {
        areas: [...new Set([...Object.keys(team), "comercial", "responsible", "leader"])],
        values: {
            ...team,
            ...teamAdminCorrectNames,
        },
    };
};

export const getDataReduxProjectDetails = (project) => {
    try {
        const {
            size,
            name,
            team,
            types,
            lists,
            client,
            status,
            pauses,
            isDeleted,
            teamAdmin,
            platforms,
            extraTime,
            percentage,
            categories,
            description,
            hasOverTime,
            hasComments,
            hasSubstasks,
            testingLists,
            clickupSpace,
            isProjectRed,
            updatedhours,
            retrospective,
            extraResources,
            timeGlobalSpent,
            timeGlobalTotal,
            calculatedHours,
            hasCommentCancel,
            hasRetrospective,
            overtimecomments,
            projectCancelcomments,
            timeGlobalExtraTime = 0,
            dates: { weeks, ...dates },
            timeGlobalUsedExtraResources,
        } = project;

        console.log(project);


        const { graphArea, tableIndication } = getTableGraphAndIndication(lists, calculatedHours);

        return {
            name,
            status,
            properties: getProperties(types),
            propertiesCard: types,
            types,
            clickupSpace,
            isProjectRed,
            percentage,
            difference: truncateFloat(calculatedHours.total - timeGlobalTotal),
            totalGlobalSpentTime: truncateFloat(timeGlobalTotal),
            totalSpentTime: truncateFloat(timeGlobalSpent),
            totalExtraResources: truncateFloat(timeGlobalUsedExtraResources),
            totalExtraTime: timeGlobalExtraTime ? truncateFloat(timeGlobalExtraTime) : 0,
            calculatedHours,
            size,
            graphArea,
            tableIndication,
            categories,
            description,
            platforms,
            testingLists,
            client,
            hasRetrospective,
            hasCommentCancel,
            hasOverTime,
            retrospective,
            projectCancelcomments,
            overtimecomments,
            team: getTeams(team, teamAdmin),
            pauses: getDatePauses(pauses),
            dates: {
                weeks,
                ...getDatesForm(dates),
                today: toDay().dayFormat,
                start: changeDateTimeZone(project.startedDate).dayFormat,
                deadLine: project.deadLine ? changeDateTimeZone(project.deadLine).dayFormat : null,
            },
            extraResources: getTableExtraResource(extraResources),
            backups: getTableBackusHours(updatedhours),
            extraTime: getTableExtraTime(extraTime),
            isDeleted,
            hasComments,
            hasSubstasks
        };
    } catch (error) {
        console.error(error);
        return null;
    }
};

const getDatePauses = (pauses = []) => {
    return pauses.map((pause) => {
        let reasonText = "";
        pause.reasons.forEach((reason, index, arr) => {
            reasonText += `${reason.reason}`;
            if (index !== arr.length - 1) {
                reasonText += " , ";
            }
        });
        return {
            ...pause,
            reason: reasonText,
            init: changeDateTimeZone(pause.startDate).dayFormat,
            close: changeDateTimeZone(pause.restart).dayFormat,
        };
    });
};

const getDatesForm = (dates = {}) => {
    return Object.entries(dates).reduce((acc, [key, value]) => {
        if (!value) {
            return {
                ...acc,
                [key]: "",
            };
        }
        return {
            ...acc,
            [key]: changeDateTimeZone(value).dayFormat,
        };
    }, {});
};

const getTableExtraResource = (extraResource = []) => {
    return extraResource.map(({ _id, comment, dates, doesHaveImpact, area, name, type, amount, currency, hours }) => {
        const datesObj = {
            start: dates?.started || "",
            end: dates?.finished || "",
        };
        const commentCopy = comment?.text || "";
        return {
            key: _id,
            doesHaveImpact,
            area,
            extraresources: name,
            typeextraresources: type,
            amount,
            currency,
            hours,
            dateStart: datesObj.start,
            dateFinished: datesObj.end,
            comment: commentCopy,
        };
    });
};

const getTableExtraTime = (extraTime = []) => {
    return extraTime.map((hrsExtra) => {
        const {
            _id,
            user: { name: nameUser },
        } = hrsExtra;
        return {
            key: _id,
            developer: nameUser,
            ...hrsExtra,
        };
    });
};
